<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/O9ufli/tc-custom/9781526708984.jpg?1729379520107" alt="This image is the cover for the book Napoleon's Imperial Guard Uniforms and Equipment. Volume 2"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Napoleon's Imperial Guard Uniforms and Equipment. Volume 2
      </h1>
      <p class="bookDescription body article font2">
        <b>The author of <i>Battle for Paris 1815</i> examines the uniforms and equipment of the cavalry of Napoleon’s Imperial Guard.</b><br/>  <br/> Few military formations have attracted more attention than Napoleon’s Imperial Guard, and fewer still have been so extravagantly clothed and accoutered with the finest materials and the brightest colors. On both campaign and parade, the Guard, and especially the cavalry regiments, provided a dazzling display of military grandeur. From the green and gold trappings of the Chasseurs à Cheval, to the multicolored Mamelukes, the Guard cavalry was among the most brilliantly dressed formations ever to grace the field of battle.<br/>  <br/> In compiling this magnificent volume, the author has collected copies of almost all the surviving documents relating to the Guard, which includes a vast amount of material regarding the issuing of dress items, even in some instances down to company level.<br/>  <br/> This information is supported by around 100 contemporary prints, many of which have never been published before, as well as images of original items of equipment held in museums and private collections across the globe. In addition, the renown military artist, Keith Rocco has produced a series of unique paintings commissioned exclusively for this book.<br/>  <br/> This glorious book is, and will remain, unsurpassed as the standard work on the clothing and equipment of the cavalry of the Imperial Guard. It is sure to be treasured by reenactors, wargamers, and modelers, as well as historians and enthusiasts as one of the most important publications ever produced on this most famous of military formations.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Paul L. Dawson
      </h2>
      
      <p class="authorDescription body article">Paul L. Dawson BSc Hons MA, MIFA, FINS, is a historian, field archaeologist and author who has written more than twenty books, his specialty being the French Army of the Napoleonic Wars. As well as speaking French and having an in-depth knowledge of French archival sources, Paul is also an historical tailor producing museum-quality replica clothing, the study of which has given him a unique understanding of the Napoleonic era.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Frontline Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e2a472f8